import { useTranslation } from 'react-i18next';

// assets
import logoEcoGagnant from 'assets/png/logo-eco-gagnant-blanc.png';
import logoDunkerque from 'assets/png/dunkerque-logo-blanc.png';
// components
import Content from 'components/Content/Content';
import 'components/EcoGagnantProgramView/ecoGagnantProgramView.scss';

const EcoGagnantProgramView = () => {
  const { t } = useTranslation();

  const buttonsConfig = [
    {
      text: t('ecoGagnantProgram.buttons.throwLess'),
      link: 'https://www.communaute-urbaine-dunkerque.fr/je-jette-moins-astuces',
      colorClass: 'green',
    },
    {
      text: t('ecoGagnantProgram.buttons.handleWater'),
      link: 'https://www.communaute-urbaine-dunkerque.fr/vie-pratique/le-cycle-de-leau/recupeau',
      colorClass: 'blue',
    },
    {
      text: t('ecoGagnantProgram.buttons.move'),
      link: 'https://www.communaute-urbaine-dunkerque.fr/aide-a-lacquisition-dun-velo',
      colorClass: 'red',
    },
    {
      text: t('ecoGagnantProgram.buttons.house'),
      link: 'https://www.communaute-urbaine-dunkerque.fr/vie-pratique/je-decouvre-laccompagnement-eco-gagnant',
      colorClass: 'orange',
    },
  ];

  return (
    <Content withOverFlow>
      <div id="eco-gagnant-program-content">
        <div id="title-wrapper">
          <h1>{t('ecoGagnantProgram.title')}</h1>
          <div id="app-logos">
            <img src={logoEcoGagnant} id="eco-gagnant" alt="Eco-gagnant" />
            <img
              src={logoDunkerque}
              id="dunkerque"
              alt="Dunkerque Grand Littoral"
            />
          </div>
          <h2>{t('ecoGagnantProgram.subtitle')}</h2>
        </div>

        <div id="buttons-wrapper">
          {buttonsConfig.map(({ link, text, colorClass }) => (
            <a
              key={text}
              className={`button ${colorClass}`}
              href={link}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>{text}</span>
            </a>
          ))}
        </div>

        <div id="helper-text">{t('ecoGagnantProgram.helper')}</div>
      </div>
    </Content>
  );
};

export default EcoGagnantProgramView;
